import {useMutation} from "@tanstack/react-query";

import {updateServiceFunctionMutationOptions} from "./update-service-function.mutation-options";

export function useUpdateServiceFunction(serviceFunctionId: string) {
  return useMutation(updateServiceFunctionMutationOptions(serviceFunctionId));
}
